/**
 * Laden: een draaiend rondje, los of met een regel tekst eronder.
 *
 * Er waren drie manieren om iets te laten draaien (de klasse .spinning, een
 * klasse .spin die het leerkrachtscherm zelf definieerde, en een span met
 * eigen keyframes). Nu is het overal het icoon met .spinning uit index.css.
 */
import React from 'react';
import { Loader } from 'lucide-react';

/** Het draaiende icoon alleen, voor in een knop. */
export function Draaier({ grootte = 16, kleur }) {
  return <Loader size={grootte} className="spinning" style={kleur ? { color: kleur } : undefined} />;
}

/** Een blok "even wachten" met tekst, in plaats van de inhoud die nog komt. */
export function Laden({ tekst = 'Laden...' }) {
  return (
    <div className="text-center" style={{ padding: '40px' }}>
      <Draaier grootte={32} />
      <p className="text-muted mt-16">{tekst}</p>
    </div>
  );
}
